






















































import { namespace } from 'vuex-class'
import { Vue, Component, Prop } from 'vue-property-decorator'
import DisabledTextInput from '@/UI/Shared/DisabledTextInput.vue'
import DisabledTextInputInlineCol from '@/UI/Shared/DisabledTextInputInlineCol.vue'
import { BatchDto } from '@/Application/Batch'
import { ProcedureDto } from '@/Application/Procedures'

const procedureStore = namespace('procedure')

@Component({
  components: {
    DisabledTextInput,
    DisabledTextInputInlineCol
  }
})
export default class DeclarationsForm extends Vue {
  @Prop({ required: true }) readonly batch!: BatchDto

  @procedureStore.Getter
  public currentProcedure!: ProcedureDto
}
